"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("@ant-design/icons");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var exportWarehouseItemsTableToExcel_1 = require("portal/components/Grid/helpers/exportWarehouseItemsTableToExcel");
var hasProjectAndWarehousePermission_1 = require("portal/pages/Projects/hasProjectAndWarehousePermission");
var hasWarehousePermission_1 = require("portal/pages/Projects/hasWarehousePermission");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ConsumeMedicationPrescriptionDialog_1 = __importDefault(require("../Dialogs/ConsumeMedicationPrescriptionDialog"));
var PrescriptionMedicationPrint_1 = __importDefault(require("../PrescriptionMedicationPrint"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var HIMSMedicationsSlice_1 = require("src/features/HIMSMedications/HIMSMedicationsSlice");
var HIMSMedicationItemsSlice_1 = require("src/features/HIMSMedicationItems/HIMSMedicationItemsSlice");
var HIMSAdmissionsSlice_1 = require("src/features/HIMSAdmissions/HIMSAdmissionsSlice");
var moment_1 = __importDefault(require("moment"));
function WarehouseMedicationTable(props) {
    var _this = this;
    var _a = (0, reduxHooks_1.useAppSelector)(function (state) { return state.HIMSMedications; }), HIMSMedications = _a.data, MedicationsStatus = _a.status;
    var _b = (0, reduxHooks_1.useAppSelector)(function (state) { return state.HIMSMedicationItems; }), HIMSMedicationItems = _b.data, MedicationItemsStatus = _b.status;
    var _c = (0, reduxHooks_1.useAppSelector)(function (state) { return state.HIMSAdmissions; }), HIMSAdmissions = _c.data, AdmissionsStatus = _c.status;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var _d = (0, react_1.useState)(false), modalState = _d[0], setModalState = _d[1];
    var warehouseId = props.warehouseId, warehouseItems = props.warehouseItems;
    var _e = (0, react_1.useState)({}), medicationAndAdmission = _e[0], setMedicationAndAdmission = _e[1];
    var _f = (0, react_1.useState)({}), admissionAfterConsume = _f[0], setAdmissionAfterConsume = _f[1];
    var _g = (0, react_1.useState)(false), readyToPrint = _g[0], setReadyToPrint = _g[1];
    (0, react_1.useEffect)(function () {
        dispatch((0, HIMSMedicationsSlice_1.fetchMedicationsByCenterStatus)({
            centerID: warehouseId,
            status: 1,
        }));
        dispatch((0, HIMSMedicationItemsSlice_1.fetchMedicationItemsByCenterStatus)({
            centerID: warehouseId,
            delivered: false,
            canceled: false,
        }));
        dispatch((0, HIMSAdmissionsSlice_1.fetchAdmissionsByCenterStatus)({
            internalPharmacy: warehouseId,
        }));
        var unsubscribe = (0, HIMSMedicationsSlice_1.subscribeToMedications)(dispatch);
        return function () {
            unsubscribe();
        };
    }, [dispatch]);
    var MedicationItemsSnapshotItems = (0, react_1.useMemo)(function () {
        return (HIMSMedicationItems !== null && HIMSMedicationItems !== void 0 ? HIMSMedicationItems : []).map(function (x, idx) {
            var data = x;
            return __assign(__assign({}, data), { id: x.id, index: idx + "" });
        });
    }, [HIMSMedicationItems]);
    var MedicationSnapshotItems = (0, react_1.useMemo)(function () {
        return (HIMSMedications !== null && HIMSMedications !== void 0 ? HIMSMedications : []).map(function (x, idx) {
            var data = x;
            return __assign(__assign({}, data), { id: x.id, index: idx + "", medication_items: MedicationItemsSnapshotItems.filter(function (mi) { return mi.medication_id == x.id; }) });
        });
    }, [HIMSMedications, MedicationItemsSnapshotItems]);
    var AdmissionSnapshotItems = (0, react_1.useMemo)(function () {
        return (HIMSAdmissions !== null && HIMSAdmissions !== void 0 ? HIMSAdmissions : []).map(function (x, idx) {
            var data = x;
            return __assign(__assign({}, data), { id: x.id, medications: MedicationSnapshotItems.filter(function (m) { return m.admission_id == x.id; }), index: idx + "" });
        });
    }, [HIMSAdmissions, MedicationSnapshotItems]);
    var print1CbRef = (0, react_1.useRef)();
    var print = (0, react_1.useCallback)(function () {
        setTimeout(function () {
            print1CbRef.current();
        }, 1500);
    }, [medicationAndAdmission]);
    if (MedicationsStatus == "loading" ||
        MedicationItemsStatus == "loading" ||
        AdmissionsStatus == "loading") {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var arrs = [];
    var filteredAdmission = AdmissionSnapshotItems.filter(function (admission) {
        return MedicationItemsSnapshotItems.find(function (mi) { return mi.admission_id == admission.id; });
    });
    var medications = filteredAdmission.map(function (admission) {
        admission.medications.map(function (medication, index) {
            var medicationByAdmission = __assign(__assign({}, medication), { admission_id: admission.id, medication_id: medication.id, index: index, prescribe_date_id: medication.date, cached_patient_name: admission.cached_patient_name, cached_sex: admission.cached_sex, cached_birthdate: admission.cached_birthdate, cached_room_name: admission.cached_room_name, department: admission.department, room: admission.cached_room_name, bed: admission.bed, admissionData: admission });
            arrs.push(medicationByAdmission);
        });
    });
    console.log({
        arrs: arrs,
        AdmissionSnapshotItems: AdmissionSnapshotItems,
        HIMSMedications: HIMSMedications,
        HIMSMedicationItems: HIMSMedicationItems,
    });
    var viewWarehouseItemsPermission = (0, hasProjectAndWarehousePermission_1.hasProjectAndWarehousePermission)(warehouseId, ["viewWarehouseItems"]);
    var columnsOfReceiveItems = [
        {
            name: "NO",
            title: t("warehouse.NO"),
            getCellValue: function (r) { return parseFloat(r.index) + 1; },
        },
        {
            name: "cached_patient_name",
            title: t("warehouse.patientName"),
        },
        {
            name: "cached_sex",
            title: t("common.cachedSex"),
        },
        {
            name: "cached_birthdate",
            title: t("common.birthDate"),
            getCellValue: function (r) {
                return t("common.date", {
                    date: (0, moment_1.default)(r.cached_birthdate).format("DD/MM/YYYY"),
                });
            },
        },
        { name: "department", title: t("common.department") },
        { name: "cached_room_name", title: t("common.room") },
        { name: "bed", title: t("common.bed") },
        {
            name: "Prescription",
            title: t("common.prescription"),
            getCellValue: function (row) {
                return viewWarehouseItemsPermission ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: function () {
                        setMedicationAndAdmission(row);
                        // const lastMedications = row.admissionMedications.filter(
                        //     (m: HimsMedication) => !(m.date.toDate().getTime() == row.prescribeDateId)
                        // )
                        // setOtherMedicationsByAdmission(lastMedications)
                        // const prescribedMedication = {
                        //     status: 2,
                        //     // prescribeDate: row.prescribeDate,
                        //     date: new Date() as any,
                        //     // medicationItems: row.medicationItems,
                        // } as HimsMedication
                        // setMedication(row)
                        // const newMedications = [...lastMedications, prescribedMedication]
                        // setMedicationsAfterConsume(newMedications)
                        setAdmissionAfterConsume(row.admissionData);
                        setModalState(true);
                    } }, { children: "Spend" }))) : null;
            },
        },
        {
            name: "printNoSpend",
            title: "Print Without Spending",
            getCellValue: function (r) {
                return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(antd_1.Button, __assign({ style: { background: "#08c873" }, type: "primary", onClick: function () {
                            setMedicationAndAdmission(r);
                            setReadyToPrint(true);
                            print();
                        } }, { children: ["Print", (0, jsx_runtime_1.jsx)(icons_1.PrinterOutlined, {})] })) }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { children: [modalState ? ((0, jsx_runtime_1.jsx)(ConsumeMedicationPrescriptionDialog_1.default, { modalState: modalState, setModalState: setModalState, warehouseId: warehouseId, warehouseItems: warehouseItems, medicationAndAdmission: medicationAndAdmission, admissionAfterConsume: admissionAfterConsume })) : null, readyToPrint ? ((0, jsx_runtime_1.jsx)(PrescriptionMedicationPrint_1.default, { printFnRef: print1CbRef, type: "none", medication: medicationAndAdmission, setMedicationAndAdmission: setMedicationAndAdmission }, medicationAndAdmission.admission_id)) : null, (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: arrs, columns: columnsOfReceiveItems, getRowId: function (r) { return r.id; } }, { children: __spreadArray(__spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({
                    pagination: true,
                    pageSize: 50,
                }), true), [(0, hasWarehousePermission_1.hasWarehousePermission)(warehouseId, [
                        "exportPrescriptionconsumptionDetails",
                    ]) ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: {
                            position: "absolute",
                            left: "65%",
                            marginTop: 16,
                            zIndex: 999,
                        }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            var fileName, fields, titles;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        fileName = "Prescription items Table";
                                        fields = [
                                        // 'warehouseId',
                                        // 'projectId',
                                        // 'cachedProductName',
                                        // 'cachedProductDescription',
                                        // 'quantity',
                                        // 'cachedProductUnit',
                                        // 'batchNumber',
                                        // 'createdAt',
                                        // 'expiryDate',
                                        ];
                                        titles = [
                                        // 'Warehouse',
                                        // 'Project',
                                        // 'Product Name',
                                        // 'Product Description',
                                        // 'Product Quantity',
                                        // 'Unit',
                                        // 'Batch Number',
                                        // 'Created At',
                                        // 'Expiry Date',
                                        ];
                                        return [4 /*yield*/, (0, exportWarehouseItemsTableToExcel_1.exportWarehouseItemsTableToExcel)([], fields, titles, fileName)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, { children: t("common.exportToExcel") }))) : null], false) }))] }));
}
exports.default = WarehouseMedicationTable;
